import { useCallback } from 'react'
import { useAuth } from '@wehunt/core-web'
import { apiFetch, type ApiFetchInit } from './apiFetch'

/**
 * The signed-in caller's shortcut: resolves the Firebase ID token and hands it
 * to `apiFetch`.
 *
 * It deliberately does NOT react to an ended sso session. `apiFetch` does, so
 * that the call sites reaching it without this hook are covered too, and a
 * second call from here would only be noise on a handler that already runs once
 * per page.
 */
export function useApiFetch() {
  const { state } = useAuth()
  return useCallback(async function call<T>(path: string, init?: Omit<ApiFetchInit, 'token'>): Promise<T> {
    if (state.status !== 'signed-in') throw new Error('Not signed in')
    const token = await state.user.getIdToken()
    return apiFetch<T>(path, { ...init, token })
  }, [state])
}
